export default class BillingInvoiceCompetence {
  competence: string;

  competenceAt: string;

  constructor(obj: any = {}) {
    this.competence = obj.competence || '';
    this.competenceAt = obj.competenceAt || '';
  }

  public static of(obj: any = {}): BillingInvoiceCompetence {
    return new BillingInvoiceCompetence(obj);
  }
}
